import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchQ2m2DNLdata = createAsyncThunk(
  "api/fetchUsers",
  async (_, { rejectWithValue }) => {
    const jwtToken = localStorage.getItem("jwt_token");
    const URL = `${process.env.REACT_APP_API_URL}/dnl_applications`;
    try {
      const response = await axios.get(URL, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "API Error");
    }
  }
);

const q2m2ApplicationsSlice = createSlice({
  name: "q2m2_applications",
  initialState: {
    loading: false,
    data: [],
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchQ2m2DNLdata.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQ2m2DNLdata.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchQ2m2DNLdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default q2m2ApplicationsSlice.reducer;
